/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_ResultInputs */

const en_wb_operations_result = /** @type {(inputs: Wb_Operations_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A prepared record and a clear exception, instead of a guess that travels downstream.`)
};

const lv_wb_operations_result = /** @type {(inputs: Wb_Operations_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sagatavots ieraksts un skaidrs izņēmums, nevis minējums, kas ceļo tālāk pa procesu.`)
};

/**
* | output |
* | --- |
* | "A prepared record and a clear exception, instead of a guess that travels downstream." |
*
* @param {Wb_Operations_ResultInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_result = /** @type {((inputs?: Wb_Operations_ResultInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_ResultInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_result(inputs)
	return en_wb_operations_result(inputs)
});